export default __webpack_public_path__ + "static/media/user-body.1ccbbfd5.png";